/**
 * @param {HTMLElement} toggleElement
 * @param {HTMLElement} mobileNav
 */
export default function initializeMobileNav(toggleElement, mobileNav) {
  toggleElement.addEventListener('click', () => {
    if (mobileNav.classList.contains('--open')) {
      mobileNav.classList.remove('--open');
      return;
    }

    mobileNav.classList.add('--open');
  });
}
